import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpInterceptorService } from './shared/services/http-interceptor.service';
import { HomeModule } from './modules/home/home.module';
import { AdminModule } from './modules/admin/admin.module';
import { SharedModule } from './shared/shared.module';
import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { AuthModule } from './modules/auth/auth.module';
import { DataModule } from './data/data.module';
import { CoreModule } from './core/core.module';
import { DecimalPipe, HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { JwtModule } from "@auth0/angular-jwt";
import { HttpInterceptorProviders } from '@modules/home/landing-page/interceptors/interceptor-provider';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import { environment } from '@environments/environment';
import { NgIdleModule } from '@ng-idle/core';
import { AmplifyAuthenticatorModule, AuthenticatorService } from '@aws-amplify/ui-angular';
import { DxMenuModule } from 'devextreme-angular';
import { licenseKey } from 'src/devextreme-license';
import { Keepalive } from '@ng-idle/keepalive';

import config from 'devextreme/core/config';


Amplify.configure(environment.config);

config({
  licenseKey
});

@NgModule({ declarations: [
        AppComponent,
        ContentLayoutComponent,
        HeaderComponent,
        FooterComponent,
        AuthLayoutComponent,
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], 
    imports: [BrowserModule,
        AppRoutingModule,
        DataModule,
        CoreModule,
        SharedModule,
        AuthModule,
        AdminModule,
        HomeModule,
        JwtModule,
        BrowserAnimationsModule,
        AmplifyAuthenticatorModule,
        DxMenuModule,
        NgIdleModule.forRoot()],
        providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true
        },
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        },
        Keepalive,
        DecimalPipe,
        HttpInterceptorProviders,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
